// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"306":"component---src-templates-landing-page-template-index-js","765":"dcdeed2c","789":"e727ab75"}[chunkId] || chunkId) + "-" + {"306":"a2f29f30ca8cc7e2f1d9","701":"d4df09e3ca28e8719a83","765":"23aacea6497b21351abe","789":"a80696be48646fbfd057","952":"a02d59a602e3c35a021c"}[chunkId] + ".js";
};